import { useState } from 'react';
import { Typography } from '@mui/material';

const FileDropZone = ({ onFileDrop, accept = '.pdf', children }) => {
    const [isDragging, setIsDragging] = useState(false);

    const getAcceptedExtensions = () => {
        return accept.split(',').map(ext => ext.trim().toLowerCase());
    };

    const isValidFile = (file) => {
        const extensions = getAcceptedExtensions();
        const fileName = file.name.toLowerCase();
        return extensions.some(ext => fileName.endsWith(ext));
    };

    const onDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(true);
    };

    const onDragLeave = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);
    };

    const onDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);

        const file = e.dataTransfer.files[0];
        if (!file) return;

        if (!isValidFile(file)) {
            return;
        }

        onFileDrop(file);
    };

    return (
        <div
            onDragOver={onDragOver}
            onDragLeave={onDragLeave}
            onDrop={onDrop}
            style={{
                border: `2px dashed ${isDragging ? '#185230' : '#b0bec5'}`,
                borderRadius: '8px',
                padding: '16px',
                backgroundColor: isDragging ? '#E8F5E9' : '#fafafa',
                transition: 'border-color 0.2s ease, background-color 0.2s ease',
            }}
        >
            {children}
            <Typography sx={{
                textAlign: 'center',
                color: isDragging ? '#185230' : '#888',
                fontFamily: 'Roboto regular, Helvetica, Arial, sans-serif',
                fontSize: '12px',
                marginTop: '10px'
            }}>
                {isDragging ? 'Drop file here' : `or drag and drop a ${accept.split(',').map(e => e.trim().replace('.', '').toUpperCase()).join('/') } file here`}
            </Typography>
        </div>
    );
};

export default FileDropZone;
